<template>
    <div class="content">
        <div class="row">
            <div class="col-md-10 flex-container-top">
                <h2 class="text-eveer">Whatsapp Group List</h2>
                <base-button v-if="role == 'Admin'" type="primary" round icon class="top-button"
                    @click="$router.push('add?id=-1')">
                    <i class="fa fa-plus"></i>
                </base-button>
            </div>
            <!-- <div class="col-md-2 flex-container-top">
                <base-button v-if="role == 'Admin'" type="primary" class="top-button pull-right"
                    @click="$router.push('list-table')">
                    List View
                </base-button>
            </div> -->
        </div>
        <div class="row mt-5">
            <div class="col-12">
                <card card-body-classes="table-full-width">
                    <h4 slot="header" class="card-title">Whatsapp Group List</h4>
                    <div>
                        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                                placeholder="Per page">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                    :label="item" :value="item">
                                </el-option>
                            </el-select>
                            <base-input>
                                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
                                </el-input>
                            </base-input>
                        </div>
                        <el-table :data="queriedData" style="font-size: 13px">
                            <el-table-column :min-width="150" align="left" label="Picture">
                                <div slot-scope="props">
                                    <div style="display: flex">
                                        <img class="group-img" :src="props.row.image" alt="..." style="height: 100px" />
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Group Name">
                                <div slot-scope="props">
                                    <div style="color: #ba54f5; font-weight: 300;">
                                        {{ props.row.group_name }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Group Link">
                                <div slot-scope="props">
                                    <div>{{ props.row.link }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Control">
                                <div slot-scope="props">
                                    <i v-if="role == 'Admin'" class="fa fa-edit text-warning icon-padding"
                                        @click="$router.push('edit?id=' + props.row._id)" title="Edit Group"
                                        style="cursor: pointer"> </i>
                                    <i v-if="role == 'Admin'" class="fa fa-trash-alt text-danger icon-padding"
                                        @click="deleteEvent(props.row._id)" title="Delete This Group"
                                        style="cursor: pointer">
                                    </i>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="">
                            <p class="card-category">
                                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <div class="row loader-pos">
            <div class="sk-chase" v-if="loading">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>

            <div class="no-data-message" v-if="noDataMessage">
                <div>There are no records found</div>
            </div>
        </div>


        <div>
            <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')">Open Modal</b-button> -->
            <b-modal id="popUpAssignModal" hide-footer>
                <template #modal-title>
                    Using <code>$bvModal</code> Methods
                </template>
                <div class="d-block text-center">
                    <h3>Hello From This Modal!</h3>
                </div>
                <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button>
            </b-modal>
        </div>
        <!-- Classic Modal -->
    </div>
</template>
 
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },
    },
    data() {
        return {
            role: window.localStorage.getItem("role"),
            noDataMessage: "",
            loading: false,
            modals_classic: false,
            actions: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 50, 100, 1000],
                total: 0,
            },
            searchQuery: "",
            propsToSearch: ["name", "email", "age"],
            tableColumns: [
                {
                    prop: "name",
                    label: "Name",
                    minWidth: 200,
                },
                {
                    prop: "email",
                    label: "Email",
                    minWidth: 250,
                },
                {
                    prop: "age",
                    label: "Age",
                    minWidth: 100,
                },
            ],
            tableData: [],
            searchedData: [],
            fuseSearch: null,
            currentOrder: {},
        };
    },
    async mounted() {
        this.loading = true;
        let test = await this.$apiService.getCall("joingroup/get-group");
        console.log(test)
        this.role = window.localStorage.getItem("role");
        var role = this.role;
        var userid = window.localStorage.getItem("userid");
        if (role == "Admin") {
            this.tableData = test.apidata.Data || [];
        }
        console.log(this.tableData)

        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ["group_name"],
            threshold: 0.3,
        });

        this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
        this.loading = false;
        if ((this.tableData || []).length == 0) {
            this.noDataMessage = true;
        }
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery(value) {
            let result = this.tableData;
            console.log(value);
            console.log(this.searchQuery);
            if (this.searchQuery !== "") {
                result = this.fuseSearch.search(this.searchQuery);
                console.log(result);
                result = result.map(a => a.item);
            }
            this.searchedData = result;
        },
    },
    methods: {
        async compare(a, b) {
            if (a > b) return +1;
            if (a < b) return -1;
            return 0;
        },
        async deleteEvent(id) {
            let confirmed = confirm("Are you sure you want to delete this event? ");
            if (confirmed === true) {
                this.loading = true;
                const del_event = await this.$apiService.postCall("joingroup/delete-group/" + id)
                if (del_event.apidata.Message !== "Success") {
                    this.$apiService.notify(del_event.apidata.Message + ".");
                } else {
                    this.$apiService.notify("Group has been deleted.", { duration: 2000 });
                    this.loading = false;
                    window.location.reload();
                }
            }
        }
    },
};
</script>

<style>
.pagination-select,
.search-input {
    width: 200px;
}

.swal2-icon-content {
    font-size: inherit !important;
}

.group-img {
    width: 100%;
    max-width: 100px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
}

.icon-padding {
    padding: 10px;
}
</style>